import { render, staticRenderFns } from "./settings-fields.vue?vue&type=template&id=e10d4564&scoped=true"
import script from "./settings-fields.ts?vue&type=script&lang=ts&external"
export * from "./settings-fields.ts?vue&type=script&lang=ts&external"
import style0 from "./settings-fields.vue?vue&type=style&index=0&id=e10d4564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10d4564",
  null
  
)

export default component.exports